import React from "react";
import { toast } from "react-toastify";
import { Form, Field } from "react-final-form";
import FinalFormInput from "components/FinalFormInput";
import axios from "utils/axios";
import MainLayout from "layout/MainLayout";

const options = ["admin", "super_user", "user"];

const SignUp = () => {
  const signUpAccount = async (val: any) => {
    try {
      await axios.post("/api/account/create", {
        ...val,
        isPending: 1,
      });
      toast.info("Please wait until it is accepted");
    } catch (error: any) {
      toast.error(error.response.data.message);
    }
  };

  const handleClick = (errors: any, values: any) => {};
  return (
    <MainLayout title="Create An Account">
      <Form
        onSubmit={(val) => signUpAccount(val)}
        render={({ handleSubmit, errors, values }) => (
          <form
            className="containers my-20 sm:my-[36px] xl:w-[613px] lg:w-[613px] md:max-w-[613px] flex flex-col"
            onSubmit={handleSubmit}
            autoComplete="off"
          >
            <h4>Please Register Here</h4>
            <div className="content grid gap-[12px] my-8">
              <Field id="title" name="title" placeholder="Title">
                {(props: any) => <FinalFormInput {...props} required />}
              </Field>
              <Field
                id="description"
                name="description"
                placeholder="Description"
              >
                {(props: any) => (
                  <FinalFormInput
                    {...props}
                    component="textarea"
                    rows={3}
                    required
                  />
                )}
              </Field>
              <Field
                id="accountId"
                name="accountId"
                placeholder="Account Address"
              >
                {(props: any) => <FinalFormInput {...props} required />}
              </Field>
              <Field id="media" name="media" placeholder="Media Link">
                {(props: any) => <FinalFormInput {...props} required />}
              </Field>
              <Field id="userType" name="userType" placeholder="User Type">
                {(props: any) => (
                  <FinalFormInput
                    {...props}
                    component="select"
                    options={options}
                    required
                  />
                )}
              </Field>
              <Field
                id="organization"
                name="organization"
                placeholder="Organization"
              >
                {(props: any) => <FinalFormInput {...props} required />}
              </Field>
            </div>
            <button
              type="submit"
              className="high-emphasis ml-auto"
              onClick={() => handleClick(errors, values)}
            >
              SUBMIT
            </button>
          </form>
        )}
      />
    </MainLayout>
  );
};

export default SignUp;
